var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 337 266",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M278.167 77.3864C291.098 -20.0014 243.281 -5.62229 174.403 17.0518C141.107 30.8287 100.499 48.5744 18.7957 156.071C-83.3336 290.441 268.188 289.33 319.957 216.077C376.612 135.911 265.631 171.801 278.167 77.3864Z",
  fill: "current"
})));
export default SvgShapeDesktop4;